/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_4_TitleInputs */

const es_home_usecases_item_4_title = /** @type {(inputs: Home_Usecases_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integración de Calendario y Documentos`)
};

const en_home_usecases_item_4_title = /** @type {(inputs: Home_Usecases_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar & Document Integration`)
};

/**
* | output |
* | --- |
* | "Calendar & Document Integration" |
*
* @param {Home_Usecases_Item_4_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_4_title = /** @type {((inputs?: Home_Usecases_Item_4_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_4_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_4_title(inputs)
	return en_home_usecases_item_4_title(inputs)
});
export { home_usecases_item_4_title as "home.usecases.item_4_title" }